import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BnbaccessBoSharedModule } from '../../shared';

import {
    AuthRequestBnbaccessService,
    AuthRequestBnbaccessPopupService,
    AuthRequestBnbaccessComponent,
    AuthRequestBnbaccessDetailComponent,
    AuthRequestBnbaccessDialogComponent,
    AuthRequestBnbaccessPopupComponent,
    AuthRequestBnbaccessDeletePopupComponent,
    AuthRequestBnbaccessDeleteDialogComponent,
    authRequestRoute,
    authRequestPopupRoute,
} from './';

let ENTITY_STATES = [
    ...authRequestRoute,
    ...authRequestPopupRoute,
];

@NgModule({
    imports: [
        BnbaccessBoSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        AuthRequestBnbaccessComponent,
        AuthRequestBnbaccessDetailComponent,
        AuthRequestBnbaccessDialogComponent,
        AuthRequestBnbaccessDeleteDialogComponent,
        AuthRequestBnbaccessPopupComponent,
        AuthRequestBnbaccessDeletePopupComponent,
    ],
    entryComponents: [
        AuthRequestBnbaccessComponent,
        AuthRequestBnbaccessDialogComponent,
        AuthRequestBnbaccessPopupComponent,
        AuthRequestBnbaccessDeleteDialogComponent,
        AuthRequestBnbaccessDeletePopupComponent,
    ],
    providers: [
        AuthRequestBnbaccessService,
        AuthRequestBnbaccessPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BnbaccessBoAuthRequestBnbaccessModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess.module.ts